export default __webpack_public_path__ + "static/media/commonroad-search.7c37dd3a.md";